import actionTypes from 'SRC/modules/redux/actionTypes'

export const setFormFields = fields => ({
  type: actionTypes.SET_FORM_FIELDS,
  payload: fields
})
